import type { ReactNode } from 'react';
import { Icon } from './Icon';
import { Illustration } from './Illustration';
import type { IconName } from './icons';

/**
 * Nothing exists yet (or a whole page's state: 403, 404): the feature's `illustration` (or an icon), a specific
 * title, ONE line saying what comes next, and optionally the primary action. Inside a list card under its toolbar,
 * never instead of it. `compact` (the small illustration) for small panels (map panel, side lists). Nothing matches
 * the filters: NoResults.
 */
export function EmptyState({ title, children, icon = 'info', action, compact, illustration }: { title: string; children?: ReactNode; icon?: IconName; action?: ReactNode; compact?: boolean; illustration?: string }) {
  return (
    <div className={compact ? 'empty compact' : 'empty'}>
      {illustration ? (
        <Illustration src={illustration} size={compact ? 'sm' : 'lg'} className="empty-illustration" />
      ) : (
        <span className="empty-icon">
          <Icon name={icon} size={compact ? 18 : 22} />
        </span>
      )}
      <b>{title}</b>
      {children && <div className="empty-text">{children}</div>}
      {action && <div className="empty-action">{action}</div>}
    </div>
  );
}
